import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinMybookingSubHeaderComponent } from './checkin-mybooking-sub-header.component';
import { ThrottleClickDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CheckinMybookingSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, ThrottleClickDirectiveModule],
  exports: [CheckinMybookingSubHeaderComponent],
})
export class CheckinMybookingSubHeaderModule {}
